/**
 * Application version + changelog.
 *
 * APP_VERSION is the current release shown in the topbar badge.
 * CHANGELOG is rendered (newest first) in the changelog modal.
 *
 * When you ship a user-facing change, bump APP_VERSION and prepend an entry.
 * Each change is written in both English and Japanese; the modal shows the
 * line matching the current UI language. Keep them short and user-facing.
 */

/** A single change, written in each supported UI language. */
export interface LocalizedChange {
  en: string;
  ja: string;
}

export interface ChangelogEntry {
  version: string;
  date: string; // ISO date, e.g. "2026-06-04"
  changes: LocalizedChange[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: "1.1.0",
    date: "2026-06-04",
    changes: [
      {
        en: "Large files (up to 30 MB) now upload directly to storage, fixing upload failures on big PDFs.",
        ja: "大きなファイル（最大30MB）をストレージへ直接アップロードするようになり、大きなPDFのアップロード失敗を修正しました。",
      },
      {
        en: "Fixed conversion of large documents that previously failed when saving the result.",
        ja: "結果の保存時に失敗していた大きなドキュメントの変換を修正しました。",
      },
      {
        en: "Image-heavy results now display reliably and no longer crash the page.",
        ja: "画像の多い変換結果が確実に表示され、ページがクラッシュしなくなりました。",
      },
      {
        en: "Added this version & changelog button.",
        ja: "このバージョン・更新履歴ボタンを追加しました。",
      },
    ],
  },
  {
    version: "1.0.0",
    date: "2026-05-20",
    changes: [
      {
        en: "Table of contents sidebar and mobile-friendly layout.",
        ja: "目次サイドバーとモバイル対応レイアウトを追加しました。",
      },
      {
        en: "Recent conversions history and conversion options panel.",
        ja: "最近の変換履歴と変換オプションパネルを追加しました。",
      },
      {
        en: "Standalone Markdown preview tool.",
        ja: "単独で使えるMarkdownプレビューツールを追加しました。",
      },
      {
        en: "OCR support for scanned PDFs and improved image grouping.",
        ja: "スキャンされたPDFのOCR対応と画像グループ化を改善しました。",
      },
      {
        en: "Light / dark theme toggle.",
        ja: "ライト／ダークテーマの切り替えを追加しました。",
      },
    ],
  },
];

export const APP_VERSION = CHANGELOG[0]?.version ?? "0.0.0";
